import CollectionsLists from './CollectionsList.container';
export default CollectionsLists;